import { useState, useEffect } from "react";
import "../challenge-joining-frames.css";
import Logo from "../../../../../ui/atoms/logo/Logo";
import BackgroundPaths from "../../../../../ui/molecules/background-paths/BackgroundPaths";
import InputText from "../../../../../ui/atoms/inputs/input-text/InputText";
import Button from "../../../../../ui/atoms/buttons/Button";
import { GiTeamIdea } from "react-icons/gi";
import { isEmpty } from "../../../../../core/utils/helpers";
import useAxiosPrivate from "../../../../../app/providers/context-provider/useAxiosPrivate";

const JoiningTeamComposeFrame = () => {
  const axiosPrivate = useAxiosPrivate();
  
  const [isSending, setIsSending] = useState(false);
  const [fieldsConfig, setFieldsConfig] = useState([]);
  const [isEmptyFieldExists, setIsEmptyFieldExists] = useState(false);

  useEffect(() => {
    const fields = Array.from({ length: 3 }, (_, index) => ({
      id: index + 1,
      name: `field-${index + 1}`,
      label: `Team Member ${index + 1}`,
      value: "",
    }));

    setFieldsConfig(fields);
  }, []);

  useEffect(() => {
    const hasEmptyField =
      fieldsConfig.length === 0 ||
      fieldsConfig.some((field) => isEmpty(field.value));

    setIsEmptyFieldExists(hasEmptyField);
  }, [fieldsConfig]);

  const onHandleFieldChange = (id, newValue) => {
    setFieldsConfig((prevState) =>
      prevState.map((field) =>
        field.id === id ? { ...field, value: newValue } : field
      )
    );
  };

  return (
    <div className="joining-frame">
      <div className="j-f-inner">
        <BackgroundPaths />
      </div>
      <div className="j-f-outer">
        <div className="j-f-outer-head">
          <Logo to={null} width={"200px"} />
          <h1>Pamoja 4 Machine Intelligence University</h1>
          <div className="w-fit-content d-flex justify-center align-center pt-md pb-md">
            <GiTeamIdea className="icon" />
            <span>Team Mode</span>
          </div>
          <p>Setup Team's Members.!</p>
        </div>
        <div className="j-f-outer-wrapper team-compose-container">
          <div className="w-full d-flex flex-col align-center p-lg">
            {fieldsConfig.map((field) => (
              <div className="w-full mb-md" key={field.id}>
                <InputText
                  name={field.name}
                  title={field.label}
                  value={field.value}
                  onChange={(e) =>
                    onHandleFieldChange(field.id, e.target.value)
                  }
                />
              </div>
            ))}
            {isSending ? (
              <>Loading</>
            ) : (
              <div className="fade-in w-fit-content">
                {!isEmptyFieldExists && (
                  <Button
                    type={"button"}
                    preferedStyle={"validate"}
                    title={"Ready to join, Go!"}
                    action={() => {}}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoiningTeamComposeFrame;
